import { Directive, effect, inject, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserStore } from 'app/core/services/user.store';

/**
 * Renders its content for admins, based on the *real* logged-in user.
 *
 * Unlike `showForAdmin` this keeps rendering while an impersonation is active,
 * so admin tooling that must survive a takeover (the action watcher) stays
 * reachable.
 */
@Directive({
  selector: '[showForOriginalAdmin]',
})
export class ShowForOriginalAdminDirective {
  readonly #templateRef = inject(TemplateRef<unknown>);
  readonly #viewContainer = inject(ViewContainerRef);
  readonly #userStore = inject(UserStore);

  #isHidden = true;

  constructor() {
    this.#viewContainer.clear();
    // No `currentUser()` gate: while impersonating, the admin flag comes from
    // `originalUser`, so admin tooling renders even if the impersonated user's
    // profile failed to load.
    effect(() => this.#updateView());
  }

  #updateView() {
    if (this.#userStore.isOriginalAdmin() && this.#isHidden) {
      this.#viewContainer.createEmbeddedView(this.#templateRef);
      this.#isHidden = false;
    } else if (!this.#userStore.isOriginalAdmin()) {
      this.#isHidden = true;
      this.#viewContainer.clear();
    }
  }
}
